// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"883ac0aa","66":"bf3880cd","453":"944b47f6","532":"7c945b8e","593":"b0ed0f53","772":"c490e687","786":"5e2e37b9","855":"0554e489","895":"70234397","914":"97e616f6"}[chunkId] + ".chunk.js";
};